var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 863,
    viewBox: "0 0 1920 863",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2923_44328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427 283.916C427 440.718 299.625 567.832 142.5 567.832C-14.625 567.832 -142 440.718 -142 283.916C-142 127.113 -14.625 0 142.5 0C299.625 0 427 127.113 427 283.916Z",
    fill: "#F9DEC9",
    fillOpacity: 0.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2923_44328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2270 283.916C2270 440.718 2142.63 567.832 1985.5 567.832C1828.37 567.832 1701 440.718 1701 283.916C1701 127.113 1828.37 0 1985.5 0C2142.63 0 2270 127.113 2270 283.916Z",
    fill: "#D7ECFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2923_44328",
    x: -436.431,
    y: -294.431,
    width: 1157.86,
    height: 1156.69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 147.216,
    result: "effect1_foregroundBlur_2923_44328"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2923_44328",
    x: 1406.57,
    y: -294.431,
    width: 1157.86,
    height: 1156.69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 147.216,
    result: "effect1_foregroundBlur_2923_44328"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/header-bg.53571bfdf4cb754fbd42b7d2164b9a82.svg";
export { ForwardRef as ReactComponent };